module.exports = __webpack_public_path__ + "img/appAsset-brand--fc.05103a42.svg";